<template>
  <div>
    <span class="sa-date sa-h-sm-up">2023-04-03</span>
    <span class="sa-black-text"
      >Nurse -<span class="sa-gray-text">Appointment ID : 123456</span></span
    >
    <div class="sa-ins-apt">
      <span class="sa-refill">Refill</span
      ><span class="sa-bupa-str"
        ><i class="icon-Insurance2"></i> Bupa Appointment</span
      >
    </div>
    <div class="sa-d-f-sbetween sa-pt10">
        <span>12 May 2023</span>
        <span>3:40 Pm</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
